import styled from 'styled-components';
import Column from './column';

const HeaderColumn = styled(Column)`
  padding: 8px;
  align-items: center;
`;
export default HeaderColumn;
